module.exports = __webpack_public_path__ + "media/Broken.38c39f28.mp3";